<template>
  <div class="documents-section">
    <div class="accordion-section">
      <div style="font-size: 18px; font-weight: 600">
        <span>
          Fecha de generación de Solicitud:
          {{ app.application.createdAt.split(" ")[0] }}
        </span>
      </div>
      <!--TITULAR-->
      <Accordion
        title="Titular"
        id="titular"
        :key="'titular'"
        :eventHub="eventHub"
      >
        <div class="accordion-header">Documentos del Solicitante</div>
        <div class="accordion-content p-3">
          <mdb-row class="mt-3">
            <mdb-col md="4">
              <label for="input_appN" class="form__label">Escrituras: </label>
              <div v-if="documentsCheckList[0].DEED_OR_AGREEMENT" >
                <div
                v-for="item in app.documents" :key="item.id"
               
                  class="input-group"
                >
                  <Btn
                     v-if="item.documentType == 'DEED_OR_AGREEMENT'"
                    :text="'Escrituras'"
                    icon="revisar"
                    :type="'primary-admin'"
                    @onClick="openModal(item.publicURL, 'Escrituras')"
                  ></Btn>

                  <button
                     v-if="item.documentType == 'DEED_OR_AGREEMENT'"
                    type="button"
                    class="btn btn-delete"
                    style="padding: 3px; position: inherit; top: 4px"
                    @click="documentsCheckList[0].DEED_OR_AGREEMENT = false"
                  >
                    <img
                      :src="'/img/icons/InoBorrar.svg'"
                      alt="icon eliminar"
                    />
                  </button>
                </div>
                
              </div>
              <div v-if="!documentsCheckList[0].DEED_OR_AGREEMENT">
                    <mdb-col md="4">
                            <label for="escrituras-input" class="btn-label">
                              <img
                                :src="'/img/icons/upload-document.svg'"
                                style="width: 20px"
                              />
                             SUBE ESCRITURAS
                            </label>
                            <input
                              type="file"
                              accept="application/pdf"
                              name="file"
                              id="escrituras-input"
                              style="visibility: hidden"
                            
                            />
                          </mdb-col>

                </div>
            </mdb-col>
            <mdb-col md="6">
              <div v-for="item in app.documents" :key="item.id">
                <Btn
                  v-if="item.documentType == 'PROPERTY_PAYMENT'"
                  :text="'Pago de predial'"
                  icon="revisar"
                  :type="'primary-admin'"
                  @onClick="openModal(item.publicURL, 'Pago predial')"
                ></Btn>
              </div>
            </mdb-col>
          </mdb-row>

          <mdb-row class="mt-3">
            <mdb-col md="4">
              <div v-for="item in app.documents" :key="item.id">
                <Btn
                  v-if="
                    item.documentType == 'INE' ||
                    item.documentType == 'PASSPORT'
                  "
                  :text="'IDENTIFICACIÓN OFICIAL'"
                  icon="revisar"
                  :type="'primary-admin'"
                  @onClick="openModal(item.publicURL, 'Identificación Oficial')"
                ></Btn>
              </div>
            </mdb-col>
            <mdb-col md="3">
              <div v-for="item in app.documents" :key="item.id">
                <Btn
                  v-if="item.documentType == 'CURP'"
                  :text="'CURP'"
                  icon="revisar"
                  :type="'primary-admin'"
                  @onClick="openModal(item.publicURL, 'CURP')"
                ></Btn>
              </div>
            </mdb-col>
            <mdb-col md="5">
              <div v-for="item in app.documents" :key="item.id">
                <Btn
                  v-if="item.documentType == 'BIRTH_CERTIFICATE'"
                  :text="'ACTA DE NACIMIENTO'"
                  icon="revisar"
                  :type="'primary-admin'"
                  @onClick="openModal(item.publicURL, 'Acta de nacimiento')"
                ></Btn>
              </div>
            </mdb-col>
          </mdb-row>
          <mdb-row class="mt-3">
            <mdb-col md="8">
              <div v-for="item in app.documents" :key="item.id">
                <Btn
                  v-if="item.documentType == 'PROOF_OF_ADDRESS'"
                  :text="'Comprobante de domicilio'"
                  icon="revisar"
                  :type="'primary-admin'"
                  @onClick="
                    openModal(item.publicURL, 'Comprobante de domicilio')
                  "
                ></Btn>
              </div>
            </mdb-col>
          </mdb-row>
          <mdb-row class="mt-3">
            <mdb-col md="6">
              <div v-for="item in app.documents" :key="item.id">
                <Btn
                  v-if="item.documentType == 'TAX_STATUS_LETTER'"
                  :text="'CONSTANCIA DE SITUACIÓN FISCAL'"
                  icon="revisar"
                  :type="'primary-admin'"
                  @onClick="
                    openModal(item.publicURL, 'Constancia de situación fiscal')
                  "
                ></Btn>
              </div>
            </mdb-col>
          </mdb-row>
          <mdb-row class="mt-3">
            <mdb-col md="6">
              <div v-for="item in app.documents" :key="item.id">
                <Btn
                  v-if="item.documentType == 'CAR_BILL'"
                  :text="'Factura de carro'"
                  icon="revisar"
                  :type="'primary-admin'"
                  @onClick="openModal(item.publicURL, 'Factira de carro')"
                ></Btn>
              </div>
            </mdb-col>
          </mdb-row>
        </div>
      </Accordion>
      <Accordion
        v-if="
          app.maritalStatus == 'MARRIED' &&
          app.application.membership.membershipName == 'Familiar'
        "
        :key="'conyuge'"
        id="conyuge"
        title="Cónyuge"
        :eventHub="eventHub"
      >
        <div class="accordion-header">Documentos del Conyuge</div>
        <div class="accordion-content p-3">
          <mdb-row class="mt-3">
            <mdb-col md="4">
              <div v-for="item in spouseData[0].documents" :key="item.id">
                <Btn
                  v-if="
                    item.documentType == 'INE' ||
                    item.documentType == 'PASSPORT'
                  "
                  :text="'IDENTIFICACIÓN OFICIAL'"
                  icon="revisar"
                  :type="'primary-admin'"
                  @onClick="
                    openModal(item.publicURL, 'Indentificación Oficial')
                  "
                ></Btn>
              </div>
            </mdb-col>
            <mdb-col md="3">
              <div v-for="item in spouseData[0].documents" :key="item.id">
                <Btn
                  v-if="item.documentType == 'CURP'"
                  :text="'CURP'"
                  icon="revisar"
                  :type="'primary-admin'"
                  @onClick="openModal(item.publicURL, 'CURP')"
                ></Btn>
              </div>
            </mdb-col>
            <mdb-col md="5">
              <div v-for="item in spouseData[0].documents" :key="item.id">
                <Btn
                  v-if="item.documentType == 'BIRTH_CERTIFICATE'"
                  :text="'ACTA DE NACIMIENTO'"
                  icon="revisar"
                  :type="'primary-admin'"
                  @onClick="openModal(item.publicURL, 'Acta de nacimiento')"
                ></Btn>
              </div>
            </mdb-col>
          </mdb-row>
          <mdb-row class="mt-3">
            <mdb-col md="6">
              <div v-for="item in spouseData[0].documents" :key="item.id">
                <Btn
                  v-if="item.documentType == 'TAX_STATUS_LETTER'"
                  :text="'CONSTANCIA DE SITUACIÓN FISCAL'"
                  icon="revisar"
                  :type="'primary-admin'"
                  @onClick="
                    openModal(item.publicURL, 'Constancia de situación fiscal')
                  "
                ></Btn>
              </div>
            </mdb-col>
          </mdb-row>
          <mdb-row class="mt-3">
            <mdb-col md="8">
              <div v-for="item in spouseData[0].documents" :key="item.id">
                <Btn
                  v-if="item.documentType == 'PROOF_OF_ADDRESS'"
                  :text="'Comprobante de domicilio'"
                  icon="revisar"
                  :type="'primary-admin'"
                  @onClick="
                    openModal(item.publicURL, 'Comprobante de domicilio')
                  "
                ></Btn>
              </div>
            </mdb-col>
          </mdb-row>
        </div>
      </Accordion>

      <div v-if="beneficiaries != null">
        <div v-for="(benef, index) in beneficiaries" :key="benef.id">
          <Accordion
            id="beneficiarios"
            :index="index"
            :key="benef.id"
            :title="
              benef.beneficiaryType == 'OLDER_CHILD'
                ? 'Hij@ mayor'
                : 'Hij@ menor'
            "
            :eventHub="eventHub"
          >
            <div class="accordion-header">
              Documentos de
              {{
                benef.name + " " + benef.lastName + " " + benef.mothersLastName
              }}
            </div>
            <div class="accordion-content p-3">
              <mdb-row class="mt-3">
                <mdb-col md="4">
                  <div v-for="item in benef.documents" :key="item.id">
                    <Btn
                      v-if="
                        item.documentType == 'INE' ||
                        item.documentType == 'PASSPORT'
                      "
                      :text="'IDENTIFIACIÓN OFICIAL'"
                      icon="revisar"
                      :type="'primary-admin'"
                      @onClick="openModal(item.publicURL, 'Indentificación')"
                    ></Btn>
                  </div>
                </mdb-col>
                <mdb-col md="3">
                  <div v-for="item in benef.documents" :key="item.id">
                    <Btn
                      v-if="item.documentType == 'CURP'"
                      :text="'CURP'"
                      icon="revisar"
                      :type="'primary-admin'"
                      @onClick="openModal(item.publicURL, 'CURP')"
                    ></Btn>
                  </div>
                </mdb-col>
                <mdb-col md="5">
                  <div v-for="item in benef.documents" :key="item.id">
                    <Btn
                      v-if="item.documentType == 'BIRTH_CERTIFICATE'"
                      :text="'ACTA DE NACIMIENTO'"
                      icon="revisar"
                      :type="'primary-admin'"
                      @onClick="openModal(item.publicURL, 'Acta de nacimiento')"
                    ></Btn>
                  </div>
                </mdb-col>
              </mdb-row>
              <mdb-row class="mt-3">
                <mdb-col md="8">
                  <div v-for="item in benef.documents" :key="item.id">
                    <Btn
                      v-if="item.documentType == 'PROOF_OF_ADDRESS'"
                      :text="'Comprobante de domicilio'"
                      icon="revisar"
                      :type="'primary-admin'"
                      @onClick="
                        openModal(item.publicURL, 'Comprobante de domicilio')
                      "
                    ></Btn>
                  </div>
                </mdb-col>
              </mdb-row>
              <mdb-row class="mt-3">
                <mdb-col md="6">
                  <div v-for="item in benef.documents" :key="item.id">
                    <Btn
                      v-if="item.documentType == 'TAX_STATUS_LETTER'"
                      :text="'CONSTANCIA DE SITUACIÓN FISCAL'"
                      icon="revisar"
                      :type="'primary-admin'"
                      @onClick="
                        openModal(
                          item.publicURL,
                          'Constancia de situación fiscal'
                        )
                      "
                    ></Btn>
                  </div>
                </mdb-col>
              </mdb-row>
            </div>
          </Accordion>
        </div>
      </div>
    </div>
    <Popup size="lg-extra2" ref="confirm" :title="titleModal">
      <div
        class="embed-responsive embed-responsive-16by9 z-depth-1-half"
        style="height: 75vh"
      >
        <iframe
          title="titulo"
          class="embed-responsive-item"
          :src="popUrl"
          allowfullscreen
        ></iframe>
      </div>
      <div class="accordion__button">
        <btn
          style="float: left"
          text="CERRAR"
          @onClick="$refs.confirm.toggleModal()"
          type="primary-block"
        />
      </div>
    </Popup>

    <Loader v-show="isLoading" />
  </div>
</template>

<script>
import { mdbContainer, mdbRow, mdbCol, mdbPopover } from "mdbvue";
import { mapActions, mapGetters } from "vuex";
import Input from "../../core/Input";
import Btn from "../../core/Button";
import Accordion from "../../core/Accordion";
import Popup from "../../core/Popup";
import Swal from "sweetalert2";
import FileSaver from "file-saver";
import Loader from "../../core/Loader";
export default {
  name: "uploadDocumentation",
  props: ["uuid", "object", "eventHub"],
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbPopover,
    Btn,
    Input,
    Accordion,
    Popup,
    Loader,
  },
  data() {
    return {
      isLoading: false,
      titleModal: "",
      popUrl: null,
      LIST_DOCUMENTS_TRANSLATE: {
        CURP: "CURP",
        INE: "Identificación",
        PASSPORT: "Pasaporte",
        PROFILE_PICTURE: "Foto",
        BIRTH_CERTIFICATE: "Acta de nacimiento",
        TAX_STATUS_LETTER: "Constancia de situación fiscal",
        DEED_OR_AGREEMENT: "Escrituras/Convenio de adhesión",
        PROPERTY_PAYMENT: "Pago de predial",
        PROOF_OF_ADDRESS: "Comprobante de domicilio",
        CAR_BILL: "Factura(s) de de auto(s)",
        LOGO: "Logotipo",
      },
      documentsCheckList: [
        {
          CURP: false,
          INE: false,
          PROFILE_PICTURE: false,
          BIRTH_CERTIFICATE: false,
          TAX_STATUS_LETTER: false,
          DEED_OR_AGREEMENT: false,
          PROPERTY_PAYMENT: false,
          PROOF_OF_ADDRESS: false,
          EXTRA_INVESTIGATION: false,
          cars: [],
        },
        {
          CURP: false,
          INE: false,
          PROFILE_PICTURE: false,
          BIRTH_CERTIFICATE: false,
          TAX_STATUS_LETTER: false,
          PROOF_OF_ADDRESS: false,
          EXTRA_INVESTIGATION: false,
        },
      ],
    };
  },
  async mounted() {
    //await this.checkList();
  },
  methods: {
    openModal(url, title) {
      this.popUrl = url;
      this.titleModal = title;
      this.$refs.confirm.toggleModal();
    },
    async checkList() {
      ///SOLICITANTE
      for (let i in this.app.documents) {
        this.documentsCheckList[0][this.app.documents[i].documentType] = true;
      }
      for (let i in this.app.cars) {
        this.documentsCheckList[0].cars.push({ CAR_BILL: true });
      }
      if (this.spouseData != null) {
        for (let i in this.spouseData[0].documents) {
          this.documentsCheckList[1][
            this.spouseData[0].documents[i].documentType
          ] = true;
        }
      }
      if (this.beneficiaries != null) {
        for (let i in this.beneficiaries) {
          let auxDoc = {};
          if (this.beneficiaries[i].beneficiaryType == "OLDER_CHILD") {
            auxDoc = {
              CURP: false,
              INE: false,
              PROFILE_PICTURE: false,
              BIRTH_CERTIFICATE: false,
              TAX_STATUS_LETTER: false,
              PROOF_OF_ADDRESS: false,
            };
          } else {
            auxDoc = {
              CURP: false,
              PROFILE_PICTURE: false,
              BIRTH_CERTIFICATE: false,
              PROOF_OF_ADDRESS: false,
            };
          }
          for(let j in this.beneficiaries[i].documents){
              auxDoc[this.beneficiaries[i].documents[j].documentType] = true
          }
          this.documentsCheckList.push(auxDoc)
        }
      }
      //console.log(this.documentsCheckList);
    },
  },
  computed: {
    ...mapGetters({
      loginUserType: "getUserType",
      app: "getApp",
    }),
    beneficiaries() {
      if (this.app.beneficiaries.length > 1) {
        return this.app.beneficiaries.filter(function (item) {
          return item.beneficiaryType != "SPOUSE";
        });
      } else {
        return [];
      }
    },
    spouseData() {
      if (this.app.beneficiaries.length > 0) {
        return this.app.beneficiaries.filter(function (item) {
          return item.beneficiaryType == "SPOUSE";
        });
      } else {
        return [{documents: []}];
      }
    },
  },
};
</script>

<style>
</style>